module.exports = __webpack_public_path__ + "img/icon-bling.77a33a7a.svg";